// Inbound Orders
const InboundView = "InboundView",
    InboundReject = "InboundReject",
    InboundAccept = "InboundAccept",
    InboundAutoAccept = "InboundAutoAccept",
    InboundCreateOrder = "InboundCreateOrder",
    InboundUpdateOrder = "InboundUpdateOrder",
    InboundReleaseToQuality = "InboundReleaseToQuality",
    CancelShipping = "CancelShipping",
    AddToStockView = "AddToStock",
    AdhocWithoutSupplier = "AdhocWithoutSupplier"

// Outbound Orders
const OutboundView = "OutboundView",
    OutboundShipOut = "OutboundShipOut",
    OutboundCreateOrder = "OutboundCreateOrder",
    OutboundUpdateOrder = "OutboundUpdateOrder",
    ComplyReceive = "ComplyReceive",
    ViewDeserializedCancelShippingHistory = "ViewDeserializedCancelShippingHistory",
    CreateDeserializedCancelShipping = "CreateDeserializedCancelShipping",
    ResendDeserializedCancelShipping = "ResendDeserializedCancelShipping";

// Outbound Vpoint Orders
const VPointOutboundView = "VPointOutboundView",
    VPointOutboundShipOut = "VPointOutboundShipOut",
    VPointOutboundCreateOrder = "VPointOutboundCreateOrder",
    VPointOutboundUpdateOrder = "VPointOutboundUpdateOrder",
    VPointOutboundNotShippedOrders = "VPointOutboundNotShippedOrders",
    VPointOutboundShippedOrders = "VPointOutboundShippedOrders",
    VPointOutboundPartialShippedOrders = "VPointOutboundPartialShippedOrders",
    VPointOutboundInProgressOrders = "VPointOutboundInProgressOrders",
    VPointAdhocOutboundView = "VPointAdhocOutboundView",
    VPointCreateDeserializedCancelShipping = "VPointCreateDeserializedCancelShipping",
    VPointViewDeserializedCancelShippingHistory = "VPointViewDeserializedCancelShippingHistory",
    VPointResendDeserializedCancelShipping = "VPointResendDeserializedCancelShipping";

// Non-Serialized
const InboundOrderNonSerialized = "InboundOrderNonSerialized",
    InboundAdhocNonSerialized = "InboundAdhocNonSerialized",
    OutboundOrderNonSerialized = "OutboundOrderNonSerialized",
    OutboundAdhocNonSerialized = "OutboundAdhocNonSerialized",
    NonSerializedActivation = "NonSerializedActivation",
    NonSerializedDecommission = "NonSerializedDecommission",
    NonSerializedDispense = "NonSerializedDispense"

// Commissioning
const CommissionOrder = "CommissionOrder"
const CreateCommissionOrder = "CreateCommissionOrder"
const EditCommissionOrder = "EditCommissionOrder"
const CommissionCloseOrder = "CommissionOrderClose"

// File
const InboundFileView = "InboundFileView",
    InboundCreateInboundFile = "InboundCreateInboundFile";

// Partners
const PartnerView = "PartnerView",
    PartnerCreate = "PartnerCreate",
    PartnerImport = "PartnerImport";

// Products
const ProductView = "ProductView",
    ProductCreate = "ProductCreate",
    ProductEdit = "ProductEdit",
    ProductImport = "ProductImport";

// Reports
const ViewProductQuantityReport = "ViewProductQuantityReport",
    ViewProductBySupplierReport = "ViewProductBySupplierReport",
    ViewProductAvailabilityReport = "ViewProductAvailabilityReport",
    SecurityAuditTrailView = "SecurityAuditTrailView",
    DownloadEventDocument = "DownloadEventDocument";

// Dashboard
const ViewProductChartsReport = "ViewProductChartsReport",
    ViewDashboardStatistics = "ViewDashboardStatistics";

// User
const UserManagement = "UserManagement";

// Virtual SKU
const VirtualMapping = "VirtualMapping";

//Super Admin
const superadmin = "superadmin";

//Tenant Settings
const NewTenant = "UploadNewTenant",
    ViewTenantSetting = "ViewTenantSetting",
    AddTenantSettings = "AddTenantSettings",
    UpdateTenantSettings = "UpdateTenantSettings";


//Point of Sale
const POS_Sell = "POS_Sell";

//CancelDispense
const CancelDispense = "CancelDispense";

//Verify status
const Verify_Status = "VerifyStatus";

//Decommission
const DecomissionView = "DecomissionView";

//Activate
const Activate = "ReActivate";

//Pack
const PackView = "PackView";
const AggregateWithExistSSCC = "AggregateWithExistSSCC";
const ViolatePackageCapacity = "ViolatePackageCapacity";
const PackByOrderByExistingSSCC = "PackByOrderByExistingSSCC"
const PackByAddByExistingSSCC = "PackByAddByExistingSSCC"
const PackByRemoveByExistingSSCC = "PackByRemoveByExistingSSCC"
const ReprintByExistingSSCC = "ReprintByExistingSSCC"
const RePrint = "RePrint";

const SSCCGenerator = "SSCC_Generator";
const SGTINGenerator = "SGTIN_Generator";
const GenerateSerialsAggregated = "GenerateSerialsAggregated";
const InputAdaptorView = "InputAdaptorView";
const DashboardView = "DashboardView";

//Unpack
const Disaggregation = "Disaggregation";

//Permit Number
const ViewPermitNumber = "ViewPermitNumber",
    CreatePermitNumber = "CreatePermitNumber",
    EditPermitNumber = "EditPermitNumber";

//Print House
const ReprintGeneratorOrders = 'ReprintSerialGeneratorOrders'

//Plant Master
const SO_Add = "SO_Add",
    SO_Push = "SO_Push",
    SO_Edit = "SO_Edit",
    SO_View = "SO_View",
    SO_Pause = "SO_Pause",
    SO_Cancel = "SO_Cancel",
    SO_Reject = "SO_Reject",
    SO_Delete = "SO_Delete",
    SO_Release = "SO_Release",
    SO_Approve = "SO_Approve",
    SO_UnAssign = "SO_UnAssign",
    SO_Complete = "SO_Complete",
    Machine_Add = "Machine_Add",
    Machine_Edit = "Machine_Edit",
    Machine_View = "Machine_View",
    SO_AssignLine = "SO_AssignLine",
    Machine_Delete = "Machine_Delete",
    SO_ProductView = "SO_ProductView",
    SO_DownloadSerials = "SO_DownloadSerials";

//Move Order
const MO_Add = "MO_Add",
    MO_Edit = "MO_Edit",
    MO_View = "MO_View",
    MO_Delete = "MO_Delete";

//Cycle Count
const CycleCount_View = "CycleCount_View",
    CycleCount_Create = "CycleCount_Create",
    CycleCount_Update = "CycleCount_Update",
    CycleCount_Start = "CycleCount_Start",
    CycleCount_Remove = "CycleCount_Remove",
    CycleCount_Cancel = "CycleCount_Cancel",
    CycleCount_Complete = "CycleCount_Complete",
    AdhocCycleCount_Create = "AdhocCycleCount_Create";
// Blind Receive
const BlindReceive_Create = "BlindReceive_Create";
// BlindReceive_View = "BlindReceive_View";

// Item Verification
const ItemVerification = "ItemVerification";

// Location
const ViewSubInventories = "ViewSubInventories"
const CreateSubInventory = "CreateSubInventory"
const UpdateSubInventory = "UpdateSubInventory"
const DeleteSubInventory = "DeleteSubInventory"

const permissions = {
    MO_Add,
    SO_Add,
    SO_Push,
    SO_View,
    MO_View,
    SO_Edit,
    MO_Edit,
    SO_Pause,
    POS_Sell,
    CancelDispense,
    CancelShipping,
    ViewDeserializedCancelShippingHistory,
    CreateDeserializedCancelShipping,
    ResendDeserializedCancelShipping,
    Activate,
    PackView,
    AggregateWithExistSSCC,
    ViolatePackageCapacity,
    PackByOrderByExistingSSCC,
    PackByAddByExistingSSCC,
    PackByRemoveByExistingSSCC,
    ReprintByExistingSSCC,
    RePrint,
    SSCCGenerator,
    SGTINGenerator,
    GenerateSerialsAggregated,
    InputAdaptorView,
    DashboardView,
    SO_Cancel,
    MO_Delete,
    SO_Reject,
    SO_Delete,
    SO_Release,
    SO_Approve,
    superadmin,
    NewTenant,
    ViewTenantSetting,
    AddTenantSettings,
    UpdateTenantSettings,
    SO_Complete,
    SO_UnAssign,
    Machine_Add,
    InboundView,
    AdhocWithoutSupplier,
    AddToStockView,
    ProductView,
    PartnerView,
    Machine_View,
    OutboundView,
    VPointOutboundView,
    VPointOutboundShipOut,
    VPointOutboundCreateOrder,
    VPointOutboundUpdateOrder,
    VPointOutboundNotShippedOrders,
    VPointOutboundShippedOrders,
    VPointOutboundPartialShippedOrders,
    VPointOutboundInProgressOrders,
    VPointAdhocOutboundView,
    VPointCreateDeserializedCancelShipping,
    VPointViewDeserializedCancelShippingHistory,
    VPointResendDeserializedCancelShipping,
    Machine_Edit,
    SO_AssignLine,
    InboundAccept,
    PartnerCreate,
    Verify_Status,
    PartnerImport,
    InboundReject,
    ProductCreate,
    ProductEdit,
    ProductImport,
    SO_ProductView,
    Machine_Delete,
    Disaggregation,
    ViewPermitNumber,
    CreatePermitNumber,
    EditPermitNumber,
    ReprintGeneratorOrders,
    UserManagement,
    VirtualMapping,
    OutboundShipOut,
    InboundFileView,
    DecomissionView,
    InboundAutoAccept,
    InboundCreateOrder,
    SO_DownloadSerials,
    InboundUpdateOrder,
    OutboundCreateOrder,
    OutboundUpdateOrder,
    ViewDashboardStatistics,
    ViewProductChartsReport,
    InboundReleaseToQuality,
    InboundCreateInboundFile,
    ViewProductQuantityReport,
    ViewProductBySupplierReport,
    ViewProductAvailabilityReport,
    SecurityAuditTrailView,
    CycleCount_View,
    CycleCount_Create,
    CycleCount_Update,
    CycleCount_Start,
    CycleCount_Remove,
    CycleCount_Cancel,
    CycleCount_Complete,
    AdhocCycleCount_Create,
    BlindReceive_Create,
    // BlindReceive_View,
    ItemVerification,
    DownloadEventDocument,
    ComplyReceive,
    InboundOrderNonSerialized,
    InboundAdhocNonSerialized,
    OutboundOrderNonSerialized,
    OutboundAdhocNonSerialized,
    NonSerializedActivation,
    NonSerializedDecommission,
    NonSerializedDispense,
    CommissionOrder,
    CreateCommissionOrder,
    EditCommissionOrder,
    CommissionCloseOrder,
    ViewSubInventories,
    CreateSubInventory,
    UpdateSubInventory,
    DeleteSubInventory
};

export default {...permissions, list: Object.values(permissions)};
